'use strict';
const getRAUrls = require('./getUrls');
const getMainUrls = require('getUrls');

module.exports = {
  'home': getRAUrls.getHomeUrl(),
  'latest-assessments': getRAUrls.getLatestAssessmentsUrl(),
  'learners-portfolios': getRAUrls.getLearnersPortfoliosUrl(),
  'reports': getRAUrls.getReportsUrl(),
  'my-profile': getRAUrls.getProfileUrl(),
  'logout': getMainUrls.getLogoutUrl(),
};
